import { ChevronRight } from 'lucide-react';

/**
 * Pruh „co je potřeba udělat" nad seznamem modulu.
 *
 * Cockpit tohle umí a finanční moduly ne: než začneš cokoli číst, víš, co po
 * tobě systém chce („Zbývají 3 kontroly"). Seznam sám o sobě to neřekne —
 * informaci má (54 dokladů čeká na schválení, dva rozvozci nejsou vyrovnaní),
 * ale nechá ji schovanou v pilulce nebo v ikonce na řádku.
 *
 * **Když není co dělat, pruh se nekreslí.** Ticho je taky informace a prázdný
 * pruh s nulou by ji přebil.
 *
 * @param {Array<{id, text, pocet?, barva?, onClick?}>} ukoly
 *        Nejnaléhavější je první; kreslí se všechny, ale první nese barvu.
 */
export default function PruhUkolu({ ukoly = [], isDark, kompaktni = false }) {
    const zive = ukoly.filter(u => u && (u.pocet == null || u.pocet > 0));
    if (zive.length === 0) return null;

    const hlavni = zive[0];
    const barva = hlavni.barva || '#F59E0B';

    return (
        <div className="shrink-0 flex flex-col" style={{ gap: 6, paddingBottom: kompaktni ? 8 : 10 }}>
            {zive.map((u, i) => {
                const b = u.barva || (i === 0 ? barva : 'var(--text-tertiary)');
                const klikaci = typeof u.onClick === 'function';
                return (
                    <button key={u.id} onClick={u.onClick} disabled={!klikaci}
                        className="flex items-center gap-2.5 w-full text-left rounded-xl"
                        style={{
                            minHeight: kompaktni ? 48 : 42,
                            padding: kompaktni ? '0 14px' : '0 12px',
                            background: i === 0 ? `${b}14` : 'transparent',
                            border: `1px solid ${i === 0 ? `${b}55` : (isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)')}`,
                            color: i === 0 ? b : 'var(--text-secondary)',
                            cursor: klikaci ? 'pointer' : 'default',
                            WebkitTapHighlightColor: 'transparent',
                        }}>
                        {u.pocet != null && (
                            <span className="tabular-nums font-bold" style={{ fontSize: kompaktni ? 16 : 15 }}>{u.pocet}</span>
                        )}
                        <span className="font-semibold truncate" style={{ fontSize: kompaktni ? 14 : 13.5 }}>{u.text}</span>
                        {klikaci && <ChevronRight size={16} style={{ marginLeft: 'auto', flexShrink: 0, opacity: 0.7 }} />}
                    </button>
                );
            })}
        </div>
    );
}
